<template>
  <div :class="classDiv1">
    <vs-switch v-model="localValue" :disabled="disabled" @click="$emit('click')" />
    <sig-button-info :text="observation" :title="label">
      <label for="" color="danger" class="vs-input--label">
        {{ label }}</label
      >
    </sig-button-info>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: {},
    label: {
      default: 'Aceitar'
    },
    disabled: {
      default: false
    },
    observation: {},
    position: {}

  },
  data () {
    return {
    }
  },
  computed: {
    localValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    classDiv1 () {
      switch (this.position) {
      case 'bottom': return 'inline-flex flex-col-reverse bg-grey-lighter'
      case 'top': return 'inline-flex flex-col bg-grey-lighter'
      case 'left': return 'inline-flex flex-row bg-grey-lighter'
      case 'right': return 'inline-flex flex-row-reverse bg-grey-lighter'
      }
    }
  }
}
</script>
